import React from 'react'

import LocationSearch from './LocationSearch'
// import UserLocationMessage from './UserLocationMessage'

import styles from './LandingPage.module.css'
import logo from '../assets/images/logo-dark@2x.png'



export default function(props) {
  const {
    locationSearchHasFocus,
    findUserLocation,
  } = props

  return (
    <div className={styles.outerContainer}>
      <div className={styles.innerContainer}>
        <img className={styles.logo} src={logo} />
        <div className={styles.LocationSearch}>
          <LocationSearch autoFocus />
        </div>
        { !locationSearchHasFocus &&
          [
          <div className={styles.findMyLocation}>
            We can find the nearest tide station to you if you give us permission to&nbsp;
            <a onClick={findUserLocation}>use your location</a>.
          </div>,
          <div className={styles.copyright}>
            © 2018 Peter Lord
          </div>
          ]
        }
      </div>
    </div>
  )
}

// export default function({
//   userLocation,
//   findUserLocation,
//   onInputFocus,
// }) {
//
//   const UserLocation = () => {
//     if (userLocation.isFetching || userLocation.error)
//       return (
//         <p className={styles.userLocationStatement}>
//           <UserLocationMessage />
//         </p>
//       )
//     else
//       return (
//         <p className={styles.userLocationStatement}>
//           or &nbsp;
//           <a onClick={findUserLocation}>
//             <FontAwesomeIcon icon={['fal','location-arrow']} />
//             &nbsp;Find nearest tide station
//           </a>
//         </p>
//       )
//   }
//
//   return (
//     <div className={styles.LandingPage}>
//       <h1>Welcome To MyTides!</h1>
//       <div className={styles.middle}>
//         <p>Search for a location</p>
//         <input type="text" onFocus={onInputFocus} />
//         <UserLocation />
//       </div>
//       <h1>&nbsp;</h1>
//     </div>
//   )
// }



// WEBPACK FOOTER //
// ./src/components/LandingPageView.js